import React, { useEffect, useState } from 'react';
import { Image, Stack, Button } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useTranslate from 'hooks/useTranslate';
import { usePreferenceJobsQuery } from 'services';
import { S3_URL } from 'constants/index';
import { useNavigate } from 'react-router-dom';
import './styles.scss';

const JobsForYou: React.FC = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();

	const queryOptions = `limit=3&page=1&orderBy=createdAt&order=DESC`;
	const { data = {}, isPending } = usePreferenceJobsQuery(queryOptions);

	const [jobs, setJobs] = useState([]);

	useEffect(() => {
		if (!isPending) {
			if (data?.success) {
				const { docs = [] } = data?.data || {};
				setJobs(docs || []);
			} else {
				setJobs([]);
			}
		}
	}, [data, isPending]);

	const onCardClick = (job: any) => {
		if (job?.isJoobleJob) {
			window.open(job?.joobleJobLink, '_blank');
		} else {
			navigate(`/job-detail/${job?.jobId}`);
		}
	};

	return (
		<>
			{jobs?.length > 0 ? (
				<div className="jobs-for-you white-box bg-white">
					<div className="heading d-flex align-items-center justify-content-between">
						<h5 className="fw-bold mb-0">{translate('Job.jobsForYou')}</h5>
						<Button
							onClick={() => navigate('/seeker/suggested-jobs')}
							className="transparent-btn mb-0 rounded-pill lh-1"
						>
							{translate('Button.seeMore')}
						</Button>
					</div>

					<Stack className="jobs-for-you-list">
						{jobs?.map((job: any, index: number) => {
							return (
								<div key={index} className="jobs-box">
									<div className="d-flex gap-3" onClick={() => onCardClick(job)}>
										<div className="jobs-box-img d-flex align-items-center justify-content-center">
											<Image
												src={
													job?.companyLogo
														? `${S3_URL}${job.companyLogo}`
														: IMAGE_PATHS.CompanyLogoDefault
												}
												alt="profile"
												className="w-auto object-fit-cover"
												loading="lazy"
											/>
										</div>
										<div className="jobs-box-content flex-1">
											{job?.title && <h6 className="fw-bold mb-1">{job.title}</h6>}
											<p className="mb-2">
												{job?.isJoobleJob ? job?.joobleJobCompany : job.companyName}
											</p>
											<div className="d-flex gap-2">
												{job?.jobType && (
													<div className="jobs-detail-box bg-white rounded-pill">{job.jobType}</div>
												)}
												{job?.workMode && (
													<div className="jobs-detail-box bg-white rounded-pill">
														{job.workMode}
													</div>
												)}
											</div>
										</div>
									</div>
									{job?.isJoobleJob && (
										<p
											style={{
												color: '#1488ff',
												fontStyle: 'italic',
												fontSize: 12,
												marginTop: 10,
												marginBottom: 0,
												textAlign: 'right',
											}}
										>
											Sourced from Jooble
										</p>
									)}
								</div>
							);
						})}
					</Stack>
				</div>
			) : (
				<></>
			)}
		</>
	);
};

export default JobsForYou;
